import { render, staticRenderFns } from "./Situacao.vue?vue&type=template&id=9054d892"
import script from "./Situacao.vue?vue&type=script&lang=js"
export * from "./Situacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports